import React from 'react';
import './App.css';
import NavBar from './Components/NavBar/NavBar';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Home from './Pages/Home/Home';
import Details from './Pages/Details/Details';
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar></NavBar>
        <Routes>
          <Route path='/' element={<Home></Home>}></Route>
          <Route path='/details/:id' element={<Details></Details>}></Route>

        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;
